module.exports = __webpack_public_path__ + "img/image138.796bdd4c.jpg";